import { render, staticRenderFns } from "./salbarzuvlul.vue?vue&type=template&id=b33e3fd4&"
import script from "./salbarzuvlul.vue?vue&type=script&lang=js&"
export * from "./salbarzuvlul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports